import { IEnv } from 'shared/types';

export function getEnv(): IEnv {
  return import.meta.env['VITE_APP_ENV'];
}

/**
 * checks if the current environment matches the passed string or is included in the given string array.
 * @param env
 */
export function isEnv(env: IEnv | IEnv[]): boolean {
  const currentEnv = getEnv();
  const envs = Array.isArray(env) ? env : [env];
  return envs.includes(currentEnv);
}
